// extracted by mini-css-extract-plugin
export default {"imageWrapper":"components-Editorials-themes-BGH-editorialHeader__imageWrapper--IaaUM"};